import { useMemo } from 'react';

import { type FieldEntry, getFieldEntries } from '@/core/dcr/fields/registry';

import { useDcrFormContext } from '../_context/DcrFormContext';

export const isSuggestible = ({ def }: FieldEntry) =>
	def.visibility === 'addable' && !def.groupWith;

export const useAddableFields = () => {
	const { entityType, isAvailable, disclosure } = useDcrFormContext();

	return useMemo(
		() =>
			getFieldEntries(entityType).filter(
				entry =>
					isSuggestible(entry) &&
					isAvailable(entry.key, entry.def) &&
					!disclosure.isAdded(entry.key)
			),
		[disclosure, entityType, isAvailable]
	);
};
